/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardOverviewResponse,
  GetDashboardOverviewApiDashboardOverviewGetParams,
  GetTeamUptimeApiDashboardUptimeGetParams,
  HTTPValidationError,
  ListTeamRequestsApiDashboardRequestsGetParams,
  RequestLogResponse,
  UptimeResponse,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getDashboardOverviewApiDashboardOverviewGetResponse200 = {
  data: DashboardOverviewResponse;
  status: 200;
};

export type getDashboardOverviewApiDashboardOverviewGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getDashboardOverviewApiDashboardOverviewGetResponseSuccess =
  getDashboardOverviewApiDashboardOverviewGetResponse200 & {
    headers: Headers;
  };
export type getDashboardOverviewApiDashboardOverviewGetResponseError =
  getDashboardOverviewApiDashboardOverviewGetResponse422 & {
    headers: Headers;
  };

export type getDashboardOverviewApiDashboardOverviewGetResponse =
  | getDashboardOverviewApiDashboardOverviewGetResponseSuccess
  | getDashboardOverviewApiDashboardOverviewGetResponseError;

export const getGetDashboardOverviewApiDashboardOverviewGetUrl = (
  params?: GetDashboardOverviewApiDashboardOverviewGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/overview?${stringifiedParams}`
    : `/api/dashboard/overview`;
};

/**
 * Team-wide usage, availability, and the models that are serving.
 *
 * Reads as fetch -> shape -> respond; the shaping steps are named functions
 * above rather than 130 lines interleaved here.
 * @summary Get Dashboard Overview
 */
export const getDashboardOverviewApiDashboardOverviewGet = async (
  params?: GetDashboardOverviewApiDashboardOverviewGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getDashboardOverviewApiDashboardOverviewGetResponse> => {
  return orvalFetch<getDashboardOverviewApiDashboardOverviewGetResponse>(
    getGetDashboardOverviewApiDashboardOverviewGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDashboardOverviewApiDashboardOverviewGetQueryKey = (
  params?: GetDashboardOverviewApiDashboardOverviewGetParams,
) => {
  return [`/api/dashboard/overview`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardOverviewApiDashboardOverviewGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetDashboardOverviewApiDashboardOverviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDashboardOverviewApiDashboardOverviewGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>
  > = ({ signal }) =>
    getDashboardOverviewApiDashboardOverviewGet(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDashboardOverviewApiDashboardOverviewGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>
  >;
export type GetDashboardOverviewApiDashboardOverviewGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetDashboardOverviewApiDashboardOverviewGet<
  TData = Awaited<
    ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetDashboardOverviewApiDashboardOverviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDashboardOverviewApiDashboardOverviewGet<
  TData = Awaited<
    ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetDashboardOverviewApiDashboardOverviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDashboardOverviewApiDashboardOverviewGet<
  TData = Awaited<
    ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetDashboardOverviewApiDashboardOverviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Dashboard Overview
 */

export function useGetDashboardOverviewApiDashboardOverviewGet<
  TData = Awaited<
    ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetDashboardOverviewApiDashboardOverviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDashboardOverviewApiDashboardOverviewGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDashboardOverviewApiDashboardOverviewGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listTeamRequestsApiDashboardRequestsGetResponse200 = {
  data: RequestLogResponse;
  status: 200;
};

export type listTeamRequestsApiDashboardRequestsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTeamRequestsApiDashboardRequestsGetResponseSuccess =
  listTeamRequestsApiDashboardRequestsGetResponse200 & {
    headers: Headers;
  };
export type listTeamRequestsApiDashboardRequestsGetResponseError =
  listTeamRequestsApiDashboardRequestsGetResponse422 & {
    headers: Headers;
  };

export type listTeamRequestsApiDashboardRequestsGetResponse =
  | listTeamRequestsApiDashboardRequestsGetResponseSuccess
  | listTeamRequestsApiDashboardRequestsGetResponseError;

export const getListTeamRequestsApiDashboardRequestsGetUrl = (
  params?: ListTeamRequestsApiDashboardRequestsGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/requests?${stringifiedParams}`
    : `/api/dashboard/requests`;
};

/**
 * The team's whole request log — every model, public ones included.
 *
 * The per-model log (`/api/models/{id}/requests`) can only show traffic to
 * a slug that already has a platform Model row, which is precisely the
 * traffic you are NOT looking for when the dashboard total doesn't add up.
 * Same gateway call; here `model` is optional and comes from the caller.
 * Opening the log is recorded in the team's audit log (TRA-1626).
 * @summary List Team Requests
 */
export const listTeamRequestsApiDashboardRequestsGet = async (
  params?: ListTeamRequestsApiDashboardRequestsGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listTeamRequestsApiDashboardRequestsGetResponse> => {
  return orvalFetch<listTeamRequestsApiDashboardRequestsGetResponse>(
    getListTeamRequestsApiDashboardRequestsGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTeamRequestsApiDashboardRequestsGetQueryKey = (
  params?: ListTeamRequestsApiDashboardRequestsGetParams,
) => {
  return [`/api/dashboard/requests`, ...(params ? [params] : [])] as const;
};

export const getListTeamRequestsApiDashboardRequestsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTeamRequestsApiDashboardRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTeamRequestsApiDashboardRequestsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>
  > = ({ signal }) =>
    listTeamRequestsApiDashboardRequestsGet(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTeamRequestsApiDashboardRequestsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>
>;
export type ListTeamRequestsApiDashboardRequestsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListTeamRequestsApiDashboardRequestsGet<
  TData = Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListTeamRequestsApiDashboardRequestsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
          TError,
          Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamRequestsApiDashboardRequestsGet<
  TData = Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTeamRequestsApiDashboardRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
          TError,
          Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeamRequestsApiDashboardRequestsGet<
  TData = Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTeamRequestsApiDashboardRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Team Requests
 */

export function useListTeamRequestsApiDashboardRequestsGet<
  TData = Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListTeamRequestsApiDashboardRequestsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTeamRequestsApiDashboardRequestsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListTeamRequestsApiDashboardRequestsGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getTeamUptimeApiDashboardUptimeGetResponse200 = {
  data: UptimeResponse;
  status: 200;
};

export type getTeamUptimeApiDashboardUptimeGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTeamUptimeApiDashboardUptimeGetResponseSuccess =
  getTeamUptimeApiDashboardUptimeGetResponse200 & {
    headers: Headers;
  };
export type getTeamUptimeApiDashboardUptimeGetResponseError =
  getTeamUptimeApiDashboardUptimeGetResponse422 & {
    headers: Headers;
  };

export type getTeamUptimeApiDashboardUptimeGetResponse =
  | getTeamUptimeApiDashboardUptimeGetResponseSuccess
  | getTeamUptimeApiDashboardUptimeGetResponseError;

export const getGetTeamUptimeApiDashboardUptimeGetUrl = (
  params?: GetTeamUptimeApiDashboardUptimeGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/uptime?${stringifiedParams}`
    : `/api/dashboard/uptime`;
};

/**
 * Ninety days of team-wide availability blocks.
 *
 * Separate from the overview because it does not depend on the requests
 * window: folding it in would refetch ninety days of blocks every time
 * someone toggles Today/7-day/30-day, and blink the band each time.
 * @summary Get Team Uptime
 */
export const getTeamUptimeApiDashboardUptimeGet = async (
  params?: GetTeamUptimeApiDashboardUptimeGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getTeamUptimeApiDashboardUptimeGetResponse> => {
  return orvalFetch<getTeamUptimeApiDashboardUptimeGetResponse>(
    getGetTeamUptimeApiDashboardUptimeGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTeamUptimeApiDashboardUptimeGetQueryKey = (
  params?: GetTeamUptimeApiDashboardUptimeGetParams,
) => {
  return [`/api/dashboard/uptime`, ...(params ? [params] : [])] as const;
};

export const getGetTeamUptimeApiDashboardUptimeGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetTeamUptimeApiDashboardUptimeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTeamUptimeApiDashboardUptimeGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>
  > = ({ signal }) =>
    getTeamUptimeApiDashboardUptimeGet(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTeamUptimeApiDashboardUptimeGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>
>;
export type GetTeamUptimeApiDashboardUptimeGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetTeamUptimeApiDashboardUptimeGet<
  TData = Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetTeamUptimeApiDashboardUptimeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
          TError,
          Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamUptimeApiDashboardUptimeGet<
  TData = Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetTeamUptimeApiDashboardUptimeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
          TError,
          Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeamUptimeApiDashboardUptimeGet<
  TData = Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetTeamUptimeApiDashboardUptimeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team Uptime
 */

export function useGetTeamUptimeApiDashboardUptimeGet<
  TData = Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetTeamUptimeApiDashboardUptimeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTeamUptimeApiDashboardUptimeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTeamUptimeApiDashboardUptimeGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
